export enum WorkflowApprovalFlowType {
  Parallel = "1",
  Sequence = "2"
}
